import React from "react";
import { Grid, Embed, Message, Image } from "semantic-ui-react";
import Picture from "./Blank.png";
import HomeCourseInfo from "./HomeCourseInfo";
 
const MainPage = () => (
  <Grid>
    <Grid.Row>
      <Grid.Column>
        <Image src={Picture} size="small" centered />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row centered>
      <Grid.Column mobile={14} tablet={12} computer={10}>
        <Embed
          id='nbGtoKJ5lFw'
          placeholder='https://i3.ytimg.com/vi/nbGtoKJ5lFw/maxresdefault.jpg'
          source='youtube'
        />
      </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Message floating size='tiny'>
            <Message.Header>
              All praise and thanks is due to Allah for blessing us with his words, The Quran.
            </Message.Header>
            I don’t know of a bigger guidance than being gifted the understanding of the Quran. I also don’t know of a bigger misguidance and punishment than being lead away from the Quran. When talking about “understanding” the Quran, we mean in three ways:
            <Message.List>
              <Message.Item>Tafsir</Message.Item>
              <Message.Item>Tajweed</Message.Item>
              <Message.Item>Memorization and implementation</Message.Item>
            </Message.List>
            On this Ahl Al Quran website we will be learning all 3 aspects of the Quran with the permission, help and guidance of Allah. The promise is that we structured this website for all levels from beginner to advance, and that it will always remain easy and achievable for everyone! Now head over to the Program on the top of the page to begin your structured journey to understanding the Quran!'
          </Message>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <HomeCourseInfo />
        </Grid.Column>
      </Grid.Row>
  </Grid>
)
export default MainPage;